import { DsmCatalogContext } from '../models/dsm-options-catalog.models';

/**
 * The API's own PDF name (`{Project} {Lot | Model-Elevation | N Models} Options Catalog {yyyy-MM-dd}.pdf`), for
 * when CORS hides Content-Disposition. `homes` are the plans printed, the first being the context.
 */
export function toCatalogPdfFileName(homes: DsmCatalogContext[], date: Date): string {
  const [home] = homes;
  const part = (value: string) => value.replace(/[^A-Za-z0-9-]+/g, ' ').trim();
  const printed = home.lotNo
    ? home.lotNo
    : homes.length === 1
      ? `${home.modelName}-${home.elevationCode}`
      : `${homes.length} Models`;
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(n => String(n).padStart(2, '0')).join('-');

  return `${part(home.projectName)} ${part(printed)} Options Catalog ${day}.pdf`;
}
